import PropTypes from "prop-types";
import React, { Component } from "react";

import "./toggle.css";

export default class Toggle extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { selected, toggleSelected } = this.props;
    return (
      <div className="toggle-container" onClick={toggleSelected}>
        <div className={`dialog-button ${selected ? "" : "disabled"}`}>
          {selected ? "°F" : "°C"}
        </div>
        <div className={`dialog-button-enabled ${selected ? "" : "enabled"}`}>
          {selected ? "°C" : "°F"}
        </div>
      </div>
    );
  }
}

Toggle.propTypes = {
  selected: PropTypes.bool.isRequired,
  toggleSelected: PropTypes.func.isRequired
};